import React, { FC } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { EmailIcon, FacebookIcon, LinkedinIcon, TwitterIcon, WhatsappIcon } from 'react-share';
import dayjs from 'dayjs';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { useStyles } from './styles';
import { EventValues } from '../EventForm/config';
import DefaultAvatar from '../../../../assets/img/icons/avatar_generic.png';
import map from '../../../../assets/img/icons/ic-map.svg';
import { CurrentUserReducer, RootReducer } from '../../../../models/Redux';
import StarIcon from '../../../../assets/rating/Red.png';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    event: EventValues;
    coverImage: string;
}

const PreviewEvent: FC<Props> = ({ isOpen, onClose, event, coverImage }) => {
    const classes = useStyles();

    const {
        user: { user_avatar, user_username },
    } = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);

    const renderShareOptions = () => (
        <>
            <Box display="flex" flexDirection="row" marginBottom="2rem" gridColumnGap="1rem">
                <FacebookIcon size={26} round />
                <TwitterIcon size={26} round />
                <LinkedinIcon size={26} round />
                <WhatsappIcon size={26} round />
                <EmailIcon size={26} round />
            </Box>

            <Typography className={classes.text}>Or copy the link here:</Typography>
            <Box className={classes.copyLinkBox} />
        </>
    );

    const renderAttendees = () => (
        <>
            <Typography className={classes.text}>5 Attendees</Typography>

            <Box display="flex" flexDirection="row" alignItems="center" marginTop="1.5rem">
                <img alt="" src={DefaultAvatar} className={classes.avatar} />
                <Typography className={classes.name}>Charles</Typography>
            </Box>

            <Box display="flex" flexDirection="row" alignItems="center" marginTop="1.5rem">
                <img alt="" src={DefaultAvatar} className={classes.avatar} />
                <Typography className={classes.name}>Cristina</Typography>
            </Box>

            <Box display="flex" flexDirection="row" alignItems="center" marginTop="1.5rem">
                <img alt="" src={DefaultAvatar} className={classes.avatar} />
                <Typography className={classes.name}>Paul</Typography>
            </Box>

            <Box display="flex" flexDirection="row" alignItems="center" marginTop="1.5rem">
                <img alt="" src={DefaultAvatar} className={classes.avatar} />
                <Typography className={classes.name}>Leo</Typography>
            </Box>

            <Box display="flex" flexDirection="row" alignItems="center" marginTop="1.5rem">
                <img alt="" src={DefaultAvatar} className={classes.avatar} />
                <Typography className={classes.name}>Faus</Typography>
            </Box>
        </>
    );

    const renderCreatorInfo = () => (
        <>
            <Grid item xs={2} md={1} className={classes.avatarGridItem}>
                <img
                    className={classes.userAvatar}
                    alt=""
                    src={user_avatar || 'https://gotmy-general-assets.s3.amazonaws.com/img/user/generic.png'}
                />
            </Grid>

            <Grid item className={classes.nameAndRatingGridItem}>
                <Typography className={classes.userName}>{user_username || 'Username'}</Typography>
                <Box>
                    <img alt="" src={StarIcon} className={classes.star} />
                    <img alt="" src={StarIcon} className={classes.star} />
                    <img alt="" src={StarIcon} className={classes.star} />
                    <img alt="" src={StarIcon} className={classes.star} />
                    <img alt="" src={StarIcon} className={classes.star} />
                </Box>
            </Grid>
        </>
    );

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box className={classes.modal}>
                <Box className={classes.modalHeader}>
                    <Box />
                    <Typography className={classes.modalTitle}>Preview of your event</Typography>
                    <Button onClick={onClose}>
                        <CloseIcon fontSize="small" />
                    </Button>
                </Box>

                <Box className={classes.modalContent}>
                    <Grid container xs={12}>
                        <Grid item md={12} lg={8} className={classes.leftColumn}>
                            <Grid container>
                                <Grid item xs={2} md={1}>
                                    <Typography className={classes.day}>
                                        {dayjs(event.date).format('D')}
                                    </Typography>
                                    <Typography className={classes.month}>
                                        {dayjs(event.date).format('MMM')}
                                    </Typography>
                                </Grid>

                                {renderCreatorInfo()}

                                <Grid item xs={12}>
                                    <Typography className={classes.title}>
                                        {event.title || 'Event name'}
                                    </Typography>
                                    <Typography className={classes.description}>
                                        {event.description || 'Event description'}
                                    </Typography>

                                    <Box
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        marginBottom="0.5rem"
                                    >
                                        <img src={map} alt="map" className={classes.eventTimeIcon} />
                                        <Typography className={classes.eventTimeText}>
                                            {i18next.t('CategoryNameFechaComponentLiveAt')}
                                            {` `}
                                            {dayjs(event.date).format('HH:mm')}
                                        </Typography>
                                    </Box>

                                    <Box>
                                        <img alt="" src={coverImage} className={classes.coverImage} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={12} lg={4} className={classes.rightColumn}>
                            {renderShareOptions()}
                            {renderAttendees()}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};

export default PreviewEvent;
